import React, { useEffect } from 'react';
var noop = function noop() {};
var RequireServiceDetails = function RequireServiceDetails(_ref) {
  var children = _ref.children,
    clearServiceDetails = _ref.clearServiceDetails,
    displayWithoutServices = _ref.displayWithoutServices,
    loadServiceDetails = _ref.loadServiceDetails,
    _ref$onServiceDetails = _ref.onServiceDetailsUpdated,
    onServiceDetailsUpdated = _ref$onServiceDetails === void 0 ? noop : _ref$onServiceDetails,
    _ref$onServiceDetails2 = _ref.onServiceDetailsUpdating,
    onServiceDetailsUpdating = _ref$onServiceDetails2 === void 0 ? noop : _ref$onServiceDetails2,
    _ref$serviceIdentitie = _ref.serviceIdentities,
    serviceIdentities = _ref$serviceIdentitie === void 0 ? null : _ref$serviceIdentitie,
    status = _ref.status,
    LoadingComponent = _ref.loadingComponent;
  useEffect(function () {
    if (serviceIdentities === null) {
      return;
    }
    if (serviceIdentities.length === 0) {
      clearServiceDetails();
      return;
    }
    onServiceDetailsUpdating();
    loadServiceDetails(serviceIdentities).then(function () {
      onServiceDetailsUpdated(true);
    });
  }, [serviceIdentities !== null && serviceIdentities.join('')]);
  if (!status.loaded && !displayWithoutServices) {
    return LoadingComponent ? /*#__PURE__*/React.createElement(LoadingComponent, null) : null;
  }
  return children;
};
export default RequireServiceDetails;